const giftCardUtility = {
    pinInputCheck: (event, enableV2GiftCardForm = false) => {
        const { value } = event.target;
        if (!value || value.match(/^[0-9]+$/) === null) return false;
        const maxLength = enableV2GiftCardForm ? 8 : 4;
        return value.length <= maxLength;
    },
    createPinEventProps: (event) => {
        const data = { giftCardPin: event.target.value };
        const eventProps = { field: 'giftCardPin', data };
        return [event, eventProps];
    },
    cardInputCheck: (event, enableV2GiftCardForm = false) => {
        const { value } = event.target;
        if (!value || value.match(/^[0-9]+$/) === null) return false;
        return value.length <= 19;
    },
    isTargetValueEmpty: (event) => {
        if (event.target.value === '') {
            return true;
        }
        return false;
    },
    createCardEventProps: (event) => {
        const data = { giftCardNum: event.target.value };
        const eventProps = { field: 'giftCardNum', data };
        return [event, eventProps];
    },
};

export default giftCardUtility;
